import styled from 'styled-components'
// import {
//   default as VARIABLES
// } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const BannerDetailFormStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */

  .main-content {
    min-height: calc(100vh - 267px);
  }

  .form {
    .result-image {
      margin-left: 162px;
      margin-bottom: 30px;
    }
  }

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
`
